import { Component, OnInit, Input } from "@angular/core";
import { CTAButtonLayout } from "../cta-button-layout";
import { CTAButtonLayoutImageTitleSubtitleContext } from "./cta-button-layout-image-title-subtitle.models";

@Component({
    selector: "dodo-cta-button-layout-image-title-subtitle",
    templateUrl: "./cta-button-layout-image-title-subtitle.component.html",
    styleUrls: ["./cta-button-layout-image-title-subtitle.component.scss"],
    standalone: false
})
export class CtaButtonLayoutImageTitleSubtitleComponent extends CTAButtonLayout
	implements OnInit {
	@Input() image: string;
	@Input() title: string;
	@Input() subtitle: string;
	@Input() imageSize: number;

	@Input() set context(ctx: CTAButtonLayoutImageTitleSubtitleContext) {
		if (ctx) {
			this.image = this.image || ctx.image;
			this.title = this.title || ctx.title;
			this.subtitle = this.subtitle || ctx.subtitle;
		}
	}

	set layoutContext(ctx: CTAButtonLayoutImageTitleSubtitleContext) {
		if (ctx) {
			this.image = this.image || ctx.image;
			this.title = this.title || ctx.title;
			this.subtitle = this.subtitle || ctx.subtitle;
		}
	}

	constructor() {
		super();
	}

	ngOnInit() {}
}
